import {Fragment} from "react";
import {Alert, Col, Row} from "react-bootstrap";

import {ErrorDto} from "../../types/ErrorDto";
import {useTypedDispatch, useTypedSelector} from "../../app/typedHooks";
import {removeError} from "./data/errorSlice";

const ErrorHandler = (): JSX.Element => {
  const dispatch = useTypedDispatch();

  const errors = useTypedSelector((state) => state.errors.errors);

  return (
    <Fragment>
      {errors.map((error: ErrorDto, index: number) => {
        return (
          <Row key={index} className="pb-1">
            <Col>
              <Alert
                className="text-center"
                variant="danger"
                onClose={() => {
                  dispatch(removeError(index));
                }}
                dismissible={true}
              >
                <h5>
                  {error.statusCode} {error.statusText}
                </h5>
                <span className="overflow-wrap-break">{error.message}</span>
              </Alert>
            </Col>
          </Row>
        );
      })}
    </Fragment>
  );
};

export default ErrorHandler;
